export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7961.f6a278d5.jpg";